import { createFileRoute } from "@tanstack/react-router";
import { AbroadGuestResult } from "@/components/abroad/AbroadGuestResult";
import { guestResultHead } from "@/components/abroad/abroad-guest-head";
import { getEduCountriesCount, type CountriesHead } from "@/lib/edu-countries-count.functions";

// Результат подбора без кабинета (en). Без индексации: личный документ по
// секретной ссылке. «_» — не вкладывать в лендинг (у него нет <Outlet/>).
export const Route = createFileRoute("/en/study-abroad_/r/$token")({
  loader: async (): Promise<CountriesHead | null> => {
    try {
      return await getEduCountriesCount();
    } catch {
      return null;
    }
  },
  head: ({ loaderData }) => guestResultHead("en", loaderData),
  component: function GuestResultRoute() {
    const { token } = Route.useParams();
    return <AbroadGuestResult lang="en" token={token} />;
  },
});
